import { useState } from "react"

import { Button, Modal } from "react-bootstrap"

import ImportErrorDetails from "./ImportErrorDetails"

interface ImportErrorDetailsProps {
  show: boolean
  importJobID: number
  pageSize?: number
  onClose?: () => void
}

function ImportErrorDetailsModal(props: ImportErrorDetailsProps) {
  const { show, importJobID, pageSize, onClose } = props
  const [showModal, setShowModal] = useState(show)

  const handleClose = () => {
    onClose?.()
    setShowModal(false)
  }

  return (
    <Modal
      backdrop="static"
      centered
      show={showModal}
      onHide={() => handleClose()}
      dialogClassName="modal-90w"
      size="xl"
    >
      <Modal.Header closeButton>
        <Modal.Title className="text-uppercase text-danger">Import errors:</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-3">
        <ImportErrorDetails importJobID={importJobID} pageSize={pageSize} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => handleClose()}>
          CLOSE
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

ImportErrorDetailsModal.defaultProps = {
  pageSize: 10,
  onClose: () => {},
}

export default ImportErrorDetailsModal
